import Vue from 'vue'
import App from './App.vue'
import router from './router/index'
import vuetify from './plugins/vuetify'
import store from './plugins/store'
import GoogleAuth from '@/plugins/google.js'
import checkView from 'vue-check-view'
// var VueScrollTo = require('vue-scrollto')
import VueScrollTo from 'vue-scrollto'

import './plugins/msg'
import './plugins/axios'

Vue.config.productionTip = false

const gauthOption = {
  clientId:'908686991261-rgrqd97qo8241oi30o5vcfgu8u9c12kn.apps.googleusercontent.com',
  // clientId:
  //   '835680536926-r9c0ana58a6jmgqk1iu1if68ifag9226.apps.googleusercontent.com',
  scope: 'profile email',
  prompt: 'select_account'
}

Vue.use(GoogleAuth, gauthOption)
Vue.use(checkView)
Vue.use(VueScrollTo)

new Vue({
  store,
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
